/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Swarmind API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import { AgentsAgentIndexEntry } from '../models';
// @ts-ignore
import { AgentsAgentRichDetail } from '../models';
// @ts-ignore
import { ApiAgentExecutePostInput } from '../models';
// @ts-ignore
import { RestErrResponse } from '../models';
/**
 * AgentGalleryApi - axios parameter creator
 * @export
 */
export const AgentGalleryApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Returns a list of available agents fetched from github index repository
         * @summary Get agents list
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiNewAPIServiceFunc13: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/gallery/agents`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a detail about exact agent
         * @summary Get exact agent
         * @param {string} name 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiNewAPIServiceFunc132: async (name: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'name' is not null or undefined
            assertParamExists('apiNewAPIServiceFunc132', 'name', name)
            const localVarPath = `/gallery/agents/{name}`
                .replace(`{${"name"}}`, encodeURIComponent(String(name)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Execute exact agent according to listed specs if it supports showcase mode
         * @summary Execute exact agent
         * @param {string} name 
         * @param {ApiAgentExecutePostInput} [apiAgentExecutePostInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiNewAPIServiceFunc133: async (name: string, apiAgentExecutePostInput?: ApiAgentExecutePostInput, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'name' is not null or undefined
            assertParamExists('apiNewAPIServiceFunc133', 'name', name)
            const localVarPath = `/gallery/agents/{name}/execute`
                .replace(`{${"name"}}`, encodeURIComponent(String(name)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiAgentExecutePostInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AgentGalleryApi - functional programming interface
 * @export
 */
export const AgentGalleryApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AgentGalleryApiAxiosParamCreator(configuration)
    return {
        /**
         * Returns a list of available agents fetched from github index repository
         * @summary Get agents list
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiNewAPIServiceFunc13(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AgentsAgentIndexEntry>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiNewAPIServiceFunc13(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['AgentGalleryApi.apiNewAPIServiceFunc13']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Returns a detail about exact agent
         * @summary Get exact agent
         * @param {string} name 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiNewAPIServiceFunc132(name: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgentsAgentRichDetail>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiNewAPIServiceFunc132(name, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['AgentGalleryApi.apiNewAPIServiceFunc132']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Execute exact agent according to listed specs if it supports showcase mode
         * @summary Execute exact agent
         * @param {string} name 
         * @param {ApiAgentExecutePostInput} [apiAgentExecutePostInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiNewAPIServiceFunc133(name: string, apiAgentExecutePostInput?: ApiAgentExecutePostInput, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiNewAPIServiceFunc133(name, apiAgentExecutePostInput, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['AgentGalleryApi.apiNewAPIServiceFunc133']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * AgentGalleryApi - factory interface
 * @export
 */
export const AgentGalleryApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AgentGalleryApiFp(configuration)
    return {
        /**
         * Returns a list of available agents fetched from github index repository
         * @summary Get agents list
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiNewAPIServiceFunc13(options?: RawAxiosRequestConfig): AxiosPromise<Array<AgentsAgentIndexEntry>> {
            return localVarFp.apiNewAPIServiceFunc13(options).then((request) => request(axios, basePath));
        },
        /**
         * Returns a detail about exact agent
         * @summary Get exact agent
         * @param {AgentGalleryApiApiNewAPIServiceFunc132Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiNewAPIServiceFunc132(requestParameters: AgentGalleryApiApiNewAPIServiceFunc132Request, options?: RawAxiosRequestConfig): AxiosPromise<AgentsAgentRichDetail> {
            return localVarFp.apiNewAPIServiceFunc132(requestParameters.name, options).then((request) => request(axios, basePath));
        },
        /**
         * Execute exact agent according to listed specs if it supports showcase mode
         * @summary Execute exact agent
         * @param {AgentGalleryApiApiNewAPIServiceFunc133Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiNewAPIServiceFunc133(requestParameters: AgentGalleryApiApiNewAPIServiceFunc133Request, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.apiNewAPIServiceFunc133(requestParameters.name, requestParameters.apiAgentExecutePostInput, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AgentGalleryApi - interface
 * @export
 * @interface AgentGalleryApi
 */
export interface AgentGalleryApiInterface {
    /**
     * Returns a list of available agents fetched from github index repository
     * @summary Get agents list
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentGalleryApiInterface
     */
    apiNewAPIServiceFunc13(options?: RawAxiosRequestConfig): AxiosPromise<Array<AgentsAgentIndexEntry>>;

    /**
     * Returns a detail about exact agent
     * @summary Get exact agent
     * @param {string} name 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentGalleryApiInterface
     */
    apiNewAPIServiceFunc132(name: string, options?: RawAxiosRequestConfig): AxiosPromise<AgentsAgentRichDetail>;

    /**
     * Execute exact agent according to listed specs if it supports showcase mode
     * @summary Execute exact agent
     * @param {string} name 
     * @param {ApiAgentExecutePostInput} [apiAgentExecutePostInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentGalleryApiInterface
     */
    apiNewAPIServiceFunc133(name: string, apiAgentExecutePostInput?: ApiAgentExecutePostInput, options?: RawAxiosRequestConfig): AxiosPromise<string>;

}

/**
 * Request parameters for apiNewAPIServiceFunc132 operation in AgentGalleryApi.
 * @export
 * @interface AgentGalleryApiApiNewAPIServiceFunc132Request
 */
export interface AgentGalleryApiApiNewAPIServiceFunc132Request {
    /**
     * 
     * @type {string}
     * @memberof AgentGalleryApiApiNewAPIServiceFunc132
     */
    readonly name: string
}

/**
 * Request parameters for apiNewAPIServiceFunc133 operation in AgentGalleryApi.
 * @export
 * @interface AgentGalleryApiApiNewAPIServiceFunc133Request
 */
export interface AgentGalleryApiApiNewAPIServiceFunc133Request {
    /**
     * 
     * @type {string}
     * @memberof AgentGalleryApiApiNewAPIServiceFunc133
     */
    readonly name: string

    /**
     * 
     * @type {ApiAgentExecutePostInput}
     * @memberof AgentGalleryApiApiNewAPIServiceFunc133
     */
    readonly apiAgentExecutePostInput?: ApiAgentExecutePostInput
}

/**
 * AgentGalleryApi - object-oriented interface
 * @export
 * @class AgentGalleryApi
 * @extends {BaseAPI}
 */
export class AgentGalleryApi extends BaseAPI implements AgentGalleryApiInterface {
    /**
     * Returns a list of available agents fetched from github index repository
     * @summary Get agents list
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentGalleryApi
     */
    public apiNewAPIServiceFunc13(options?: RawAxiosRequestConfig) {
        return AgentGalleryApiFp(this.configuration).apiNewAPIServiceFunc13(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns a detail about exact agent
     * @summary Get exact agent
     * @param {AgentGalleryApiApiNewAPIServiceFunc132Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentGalleryApi
     */
    public apiNewAPIServiceFunc132(requestParameters: AgentGalleryApiApiNewAPIServiceFunc132Request, options?: RawAxiosRequestConfig) {
        return AgentGalleryApiFp(this.configuration).apiNewAPIServiceFunc132(requestParameters.name, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Execute exact agent according to listed specs if it supports showcase mode
     * @summary Execute exact agent
     * @param {AgentGalleryApiApiNewAPIServiceFunc133Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentGalleryApi
     */
    public apiNewAPIServiceFunc133(requestParameters: AgentGalleryApiApiNewAPIServiceFunc133Request, options?: RawAxiosRequestConfig) {
        return AgentGalleryApiFp(this.configuration).apiNewAPIServiceFunc133(requestParameters.name, requestParameters.apiAgentExecutePostInput, options).then((request) => request(this.axios, this.basePath));
    }
}

